module.exports = __webpack_public_path__ + "img/_weapon_potion_07.09110ef4.png";